module.exports = __webpack_public_path__ + "static/media/financiaciones.6424e9d0.svg";